import { useNavigate } from 'react-router-dom';
import { useNotifications } from '@/services/queries/useNotifications';

/**
 * Topbar notification bell for sales reps (Glaukos / Topcon). Shows an unread
 * badge and navigates to the Notification Centre. Notifications are a
 * SALES_REP-only feature on the backend, so this is not rendered for admins.
 */
export function NotificationBell() {
  const navigate = useNavigate();
  const { data } = useNotifications({ limit: 50 });

  // The list endpoint body has shifted shapes across versions; support both,
  // and prefer the server-provided unreadCount when present.
  const list: Array<{ isRead?: boolean }> =
    (data as any)?.notifications ?? (data as any)?.data ?? [];
  const unread: number =
    (data as any)?.unreadCount ?? list.filter((n) => !n?.isRead).length;

  return (
    <button
      type="button"
      onClick={() => navigate('/notifications')}
      aria-label={unread > 0 ? `Notifications, ${unread} unread` : 'Notifications'}
      style={{
        position: 'relative',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#3a3458',
      }}
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      {unread > 0 && (
        <span
          style={{
            position: 'absolute',
            top: 2,
            right: 2,
            minWidth: 16,
            height: 16,
            padding: '0 4px',
            borderRadius: 8,
            background: '#ff4d6d',
            color: 'white',
            fontSize: 10,
            fontWeight: 700,
            lineHeight: '16px',
            textAlign: 'center',
          }}
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
}
